import * as React from "react";

// 3-tier breakpoints (Phase 1 foundation)
// Mobile (phone):  < 768px
// Tablet:          768px – 1024px
// Desktop:         > 1024px
export const PHONE_BREAKPOINT = 768;
export const TABLET_MAX_BREAKPOINT = 1025; // exclusive upper bound

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${PHONE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(window.innerWidth < PHONE_BREAKPOINT);
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < PHONE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
